module.exports = __webpack_public_path__ + "static/img/352.5ca8b15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/news/352.png
// module id = yydy
// module chunks = 0